export const LIVE_MEETING_ROUTE = '/liveMeeting';
export const LIVE_MEETING_PARTICIPANT_ROUTE = '/liveMeetingParticipant';
export const LIVE_MEETING_TAB = '/dashboard/new/liveMeetings';
export const LIVE_MEETING_PARTICIPANTS = 'participants';
export const LIVE_MEETING_GEO = 'geo';

export const LIVE_MEETING_REFRESH_TIME = 3 * 1000;
export const LIVE_MEETING_SLOW_REFRESH_TIME = 10 * 1000;
export const LIVE_MEETING_INACTIVITY_TIMEOUT = 30 * 1000;
